var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhileHovering = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5592 9.65258V5.96008C10.5592 5.28008 10.0084 4.72925 9.3284 4.72925C8.6484 4.72925 8.09756 5.28008 8.09756 5.96008V13.0626L5.89256 11.9309C5.3909 11.6734 4.78006 11.7692 4.38173 12.1676C3.85423 12.6951 3.87923 13.5576 4.4359 14.0542L8.45673 17.6401C8.76173 17.9126 9.15673 18.0626 9.5659 18.0626H13.4267C14.2076 18.0626 14.8842 17.5201 15.0534 16.7576L15.9476 12.7326C16.2084 11.5576 15.4226 10.4059 14.2334 10.2217L10.5592 9.65258Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60913 3.89576C7.63746 1.2841 10.9266 1.2841 12.955 3.89576",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhileHovering);
export default ForwardRef;